import { z } from 'zod';

import { accepted, email, phone, required, tooLong } from '@mds/shared/lib/validation';

import { DESK_PAYMENT_METHODS } from './desk-booking.schema';

/**
 * Who is booking a meeting room and how they will pay, checked before the
 * request is saved and handed to WhatsApp. The room, day and hours come from
 * the calendar, so they are not fields here. The same limits as the desk
 * booking, and the same two ways to pay.
 */
export const roomBookingSchema = z.object({
  fullName: required('Full name').max(160, tooLong(160)),
  email,
  phone,
  paymentMethod: z
    .union([z.literal(''), z.enum(DESK_PAYMENT_METHODS)])
    .refine((value) => value !== '', 'Choose how you will pay.'),
  policyAccepted: accepted('Please accept the booking and use terms to continue.'),
});

export type RoomBookingForm = z.input<typeof roomBookingSchema>;
export type RoomBooking = z.output<typeof roomBookingSchema>;
